import { Injectable } from '@angular/core';
import { Agent } from '../models/agent'
import { environment } from '../../environments/environment';
import { Deliverable } from '../models/deliverable';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class DeliverableService {

  constructor(private http: HttpClient) {}

  getDeliverable(id: string) {
      const url = `${environment.apiUrl}deliverables/${id}`;
      return this.http.get<Deliverable>(url);
    }

    getDeliverables() {

    }
}
